import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ParkingWebStampHistoryRow } from '../../../../../core/models/parking/parking-web-stamp-history.model';

@Component({
  selector: 'app-modal-web-stamp-history-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-web-stamp-history-detail.component.html',
  styleUrl: './modal-web-stamp-history-detail.component.css',
})
export class ModalWebStampHistoryDetailComponent {
  @Input({ required: true }) item!: ParkingWebStampHistoryRow;
  @Output() close = new EventEmitter<void>();
  @Output() openImage = new EventEmitter<string>();

  onClose(): void {
    this.close.emit();
  }

  onOpenImage(): void {
    if (this.item?.pictureUrl) this.openImage.emit(this.item.pictureUrl);
  }

  formatStampTime(value: string | null): string {
    if (!value) return '—';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
  }
}
